import { render, staticRenderFns } from "./saveChannel.vue?vue&type=template&id=5b532a37&"
import script from "./saveChannel.vue?vue&type=script&lang=js&"
export * from "./saveChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports